import { jsx, jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { memo, useState } from "react";
import { selectMatched } from "../utils/selectMatched.js";
import "../../../Button/Button.js";
import "../../../InputControl/InputControl.js";
import "../../../InputControl/Input/InputBase.js";
import "../../../PhoneInputControl/PhoneInputControl.js";
import "../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../IconButton/IconButton.js";
import "../../../common/ControlBody.js";
import "../../../SelectControl/Select/context/SelectContext.js";
import "../../../Dialog/Dialog.js";
import "../../../IconButtonNew/IconButton.js";
import "../../../../icons/24/Action/Close.js";
import "../../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../../utils/dataTestId.js";
import "../../../SelectControl/Select/components/SelectInput/SelectInput.js";
import { DATA_TEST_ID_INHERITED } from "../../../../constants/DATA_TEST_ID_INHERITED.js";
import "../../../SelectControl/Select/MultiSelect/context/MultiSelectContext.js";
import "../../../../icons/24/System/Check.js";
import "../../../../icons/24/Arrow/ChevronDown.js";
import "../../../TextareaControl/TextareaControl.js";
import "../../../SearchControl/SearchControl.js";
import "../../../../icons/24/System/Search.js";
import "../../../FormattedPhone/FormattedPhoneNumber.js";
import { Tooltip } from "../../../Tooltip/Tooltip.js";
import "../../../Avatar/styles.js";
import "../../../CheckboxGroup/Checkbox/styles.js";
import "../../../CheckboxGroup/styles.js";
import "../../../RadioGroup/Radio/styles.js";
import "../../../RadioGroup/styles.js";
import "../../../RatingButton/styles.js";
import "../../../FloatingActionButton/styles.js";
import "../../../SortingButton/styles.js";
import "../../../SquareButton/styles.js";
import "../../../Toggle/styles.js";
import "../../../Dialog/StyledDialog.js";
import "../../../Chips/Chip/styles.js";
import "../../../ResultMarksNumber/styles.js";
import "../../../Progress/ProgressCircle/styles.js";
import "../../../Loaders/LoaderCircle/styles.js";
import "../../../Loaders/LoaderLine/styles.js";
import "../../../SegmentedControl/styles.js";
import "../../../ResultMarksText/styles.js";
import "../../../Link/styles.js";
import "../../../Tag/Tag.js";
import "../../../DatePicker/constants.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../external/classnames/index.js";
import "../../../Scrollbar/Scrollbar.js";
import "../../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../MobileBottomSheet/MobileBottomSheet.js";
import "../../ListItem/ListItem.js";
import "../../../Nowrap.js";
import "../TreeListItem.js";
const Label = memo(({ label, lines, match, disabled, htmlFor, ...props }) => {
  const [tooltipCanBeShown, setTooltipIsEnabled] = useState(!1), tooltipIsNeeded = label.length > 50 && lines === 1;
  let content = (htmlFor2) => /* @__PURE__ */ jsx(
    Typography,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      component: "label",
      className: "contentContainer no-match-content",
      sx: [
        styles.label,
        lines === 1 ? { whiteSpace: "nowrap" } : {},
        disabled ? styles.disabled : {}
      ],
      onClick: () => setTooltipIsEnabled(!0),
      htmlFor: htmlFor2,
      ...props,
      children: label
    }
  );
  if (match) {
    const txtObj = selectMatched(match, label);
    match && txtObj.selected && (content = (htmlFor2) => /* @__PURE__ */ jsxs(
      Typography,
      {
        "data-test-id": DATA_TEST_ID_INHERITED,
        component: "label",
        className: "contentContainer match-content",
        sx: [
          styles.label,
          lines === 1 ? { whiteSpace: "nowrap" } : {},
          disabled ? styles.disabled : {}
        ],
        onClick: () => setTooltipIsEnabled(!0),
        htmlFor: htmlFor2,
        ...props,
        children: [
          txtObj.start ? /* @__PURE__ */ jsx("span", { children: txtObj.start }) : null,
          txtObj.selected ? /* @__PURE__ */ jsx("strong", { children: txtObj.selected }) : null,
          txtObj.end ? /* @__PURE__ */ jsx("span", { children: txtObj.end }) : null
        ]
      }
    ));
  }
  return !tooltipIsNeeded || !tooltipCanBeShown ? content(htmlFor) : /* @__PURE__ */ jsx(
    Tooltip,
    {
      title: label,
      placement: "top",
      onClose: () => setTooltipIsEnabled(!1),
      "data-test-id": inheritDataTestId(props, "tooltip"),
      children: content()
    }
  );
});
Label.displayName = "Label";
const styles = {
  label: {
    typography: { xs: "12_18_500", sm: "14_18_500" },
    width: "100%",
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer"
  },
  disabled: {
    color: (t) => t.palette.ddrow.content.disabled
  }
};
export {
  Label
};
//# sourceMappingURL=Label.js.map
